import axios from 'axios';
import { useRef, useState, useEffect, useContext } from 'react';
import './Register.css'
import { useNavigate, useParams } from 'react-router-dom';
import React from 'react';
import config from '../../config';
import { AuthContext } from '../../context/AuthContext';
import Popup from '../../components/popup/Popup';

export default function Register() {
  const { inviteId } = useParams();
  const username = useRef();
  const email = useRef();
  const password = useRef();
  const passwordAgain = useRef();
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [isInviteValid, setIsInviteValid] = useState(null);
  const { user } = useContext(AuthContext);

  const popupStatus = async (message) => {
    setPopupMessage(message);
    setShowPopup(true);
  }
  // validate invite before accessing page
  useEffect(() => {
    const validateInvite = async () => {
      try {
        const response = await axios.get(`${config.apiUrl}/invites/accept/${inviteId}`);
        if (response.data.length > 0 && !user) {
          setIsInviteValid(true);
        } else {
          setIsInviteValid(false);
          popupStatus('Invalid or expired invite link.');
          setTimeout(() => navigate('/'), 3000); // Redirect to home after 3 seconds
        }
      } catch (error) {
        setIsInviteValid(false);
        popupStatus('An error occurred while validating the invite link.');
        setTimeout(() => navigate('/'), 3000); // Redirect to home after 3 seconds
      }
    };

    if (inviteId) {
      validateInvite();
    } else {
      setIsInviteValid(false);
      popupStatus('No invite provided.');
      setTimeout(() => navigate('/'), 2000);
    }
  }, [inviteId]);


  const handleClick = async (e) => {
    e.preventDefault();
    if(passwordAgain.current.value !== password.current.value){
      passwordAgain.current.setCustomValidity("passwords do not match");
    } else {
      const user = {
        username: username.current.value,
        email: email.current.value,
        password: password.current.value,
        inviteCode: inviteId
      };
      try {
        await axios.post(`${config.apiUrl}/api/auth/register`, user);
        navigate('/login'); // Navigate on successful registration
      } catch (err) {
        if (err.response && err.response.status === 400) {
            // Handle specific 400 error response for username/email exists
            await popupStatus('Username or Email already exists.', "Close");
        } else {
            // Handle other errors
            await popupStatus('An error occurred when trying to register. Please try again later.', "Close");
        }
      }
    }
  };

  if (user) {
    return <div className='valid-user-container'>
      <p>
      You already have an account. Send the invite to someone who doesn&apos;t
      </p>
      </div>; // Show a loading indicator while validating
  }

  return (
    <div className="login">
        <Popup isPopupOpen={showPopup} message={popupMessage} button1Text="Close" button1Action={() => setShowPopup(false)} />
        {isInviteValid && 
          <div className="registerWrapper">
                  <form className="registerBox" onSubmit={handleClick}>
                      <input placeholder='Username' required ref={username} className="registerInput" minLength='3' maxLength='15'/>
                      <input placeholder='Email' required ref={email} className="registerInput" type="email" minLength='5' maxLength='35'/>
                      <input placeholder='Password' required ref={password} className="registerInput" type="password" minLength='6' maxLength='35' />
                      <input placeholder='Confirm Password' required ref={passwordAgain} className="registerInput" type="password" minLength='6'maxLength='35'/>
                      <button className="signUpButton" type='submit'>Sign Up</button>
                  </form>
            
          </div>
        }
    </div>
  )
}
